<ng-container *ngIf="!(isPartOfArNavigation$  | async)">
    <div class="alert alert-danger">{{ 'aumico_reports_page_is_not_part_of_ar_navigation' | i18next }}</div>
</ng-container>

<ng-container *ngIf="(isPartOfArNavigation$  | async)" content [ngSwitch]="dataState">
    <div style="grid-column: 1/17; padding: 16px 16px 0 32px">
        <aumico-financial-closing-process-adapter
            #fcpAdapter
            (finalizeAndContinueButtonClicked)="finalizeAndContinue()"
        ></aumico-financial-closing-process-adapter>
        <div *ngSwitchCase="'loading'"><mat-progress-spinner mode="indeterminate"></mat-progress-spinner></div>

        <ng-container *ngSwitchCase="'success'"> </ng-container>

        <div *ngSwitchCase="'error'" class="alert alert-danger">
            {{ "aumico_reports_required_data_not_completed" | i18next }}
        </div>
        <div *ngSwitchDefault class="alert alert-danger">"{{ 'aumico_reports_fcp_unknown_state' | i18next }}"</div>
    </div>
</ng-container>

<ng-template #footerTemplate>
    <aum-action-bar-pure
        [extraActionButtons]="footerExtraButtonActions"
        nextButtonPrefixText="{{nextStepPrefix |  i18next}}"
        nextButtonText="{{nextStepLabel |  i18next}}"
        nextButtonRouterLink="../{{nextStepPath}}"
        [nextButtonAction]="proceedButtonClicked"
        [nextButtonDisabled]="disableProceedButton"
        backButtonPrefixText="{{previousStepPrefix |  i18next}}"
        backButtonText="{{previousStepLabel |  i18next}}"
        backButtonRouterLink="../{{previousStepPath}}"
        [backButtonIcon]="previousStepIcon"
    ></aum-action-bar-pure>
</ng-template>
